import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import React from "react";
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Incubation = () => {
  const title = "From incubation to scale up - {BRAND.domainLabel}, a UK tech startup redefining social media, marks monumental move during UK Mental Health Awareness Month."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on May 29, 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                {BRAND.domainLabel} is a UK tech startup which presents an alternative
                future for social networking, one which is better for mental
                health. Built from the ground up it embodies safety by design.
              </p>

              <p>
                Social media algorithms and trolling are contributing to the
                mental health crisis while social unrest has been perpetuated by
                misinformation online. These combined factors are costing the UK
                taxpayer millions while also resulting in lives lost and an
                ever-increasing burden on NHS resources. {BRAND.domainLabel} is an
                alternative option, one that provides the positives of social
                media expression and connection without the fear and harm to
                one’s mental health. It is celebrating this mindful mission on
                Mental Health Week by moving to scale up. It is opening its
                platform to users to sign up, while also onboarding its waitlist
                users. Collectively, it is championing a movement to stand up
                for a better online world. {BRAND.domainLabel} marks a fundamental
                shift for the better in the impact on mental health from social
                media.
              </p>

              <p>
                {BRAND.domainLabel} has a subscription rather than an advertising
                model, with the basic tier starting at just 99p per month
                excluding taxes and charges. This fee supports not only the
                platform’s safety infrastructure but also direct charitable
                donations, distributed based on where users choose to focus
                their attention. Every user on {BRAND.domainLabel} helps to create a
                more compassionate world online and offline, whether passive or
                active, as a portion of the subscription fee is donated to
                charities that save lives, promote better mental health and
                foster compassionate communities. The charities are chosen by
                the founders to champion {BRAND.domainLabel}’s values, while also
                countering the chaos and cost that the online world is currently
                imposing on society.
              </p>

              <p>
                The platform makes a commitment to keep their users safe by
                ensuring all content is moderated before going live. All content
                is assessed against {BRAND.domainLabel}’s policies to ensure content is
                age appropriate. {BRAND.domainLabel} has developed their policies on
                age-appropriateness in consultation with the UK’s independent
                film and video regulator, the British Board of Film
                Classification (BBFC), whose classification guidelines are based
                on extensive consultation with thousands of people across the UK
                and are refreshed every four to five years to ensure they
                continue to reflect the expectations of UK audiences. The age
                brackets are inspired by BBFC content classification standards,
                which {BRAND.domainLabel} has built to enhance safety for all their
                users.
              </p>

              <p>
                The founders, UK entrepreneurs and parents Harleen and Andrew
                Ahluwalia-Cook, were driven by a deeply personal vision. They
                were determined to create a social media platform they wish
                they’d had growing up—and one their children could ultimately
                use to thrive, not just survive, in the digital world.
              </p>

              <p>
                Commenting on the announcement, Harleen Ahluwalia-Cook stated:
                “Too many families are being torn apart due to current social
                media platforms. Social media is integral to youth culture, but
                the current platforms are posing dangers to society. The Online
                Safety Act is brilliant but doesn’t go far enough. This is why
                entrepreneurs, parents and charities need to come together to
                create a solution we know that everyone truly deserves.”
              </p>

              <p>
                Andrew Ahluwalia-Cook further commented: “Collaboration not
                conflict will bring us together as a community, this has to
                happen online for us to see the changes in the real world.
                That’s our mission with {BRAND.domainLabel}.”
              </p>

              <p>
                This isn’t just another app launch. It’s an invitation to
                changemakers -who believe social media can do better, and who
                want to be part of building a safer, more hopeful online future.
                Those brave enough to imagine a better world deserve a platform
                that protects them, like {BRAND.domainLabel}.
              </p>

              <p>
                Early access begins this week for waiting list members and
                select UK communities. Broader availability is planned for later
                this years
              </p>

              <p>
                Join us in rewriting the story of social media—one mindful
                moment at a time. Visit {BRAND.domainLabel}.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Incubation;
